$(document).on("turbolinks:load", () => {
  // fix duplicate requests: https://stackoverflow.com/a/78263792/13552638
  $("a").attr("data-turbolinks", "false");
});
